import { PosDecimal } from "./maths";

export const tax = 0.1 as PosDecimal; // 10 % GST
export const admin = 0.15 as PosDecimal; // percentage of royalty that is admin fee
export const royalty_fraction = 0.05 as PosDecimal; // royalty percentage
export const eligibility_date = new Date("2010-06-08"); //artworks must be sold after the 8th of June 2010
export const threshold_price: number = 1000; // minimum price that will incur a royalty
export const opt_out_days: number = 21; // number of days for opt out period.
export const auto_resale_status_update_period = {
  days: 3,
  hours: 23,
  minutes: 59,
}; // used for the automated update of Provisionally eligible to Research Required in resales.
export const REMITTANCE_PATH = "remittance/";
